import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
  OffersOverviewAdminQueryQuery, 
  OffersOverviewAdminQueryQueryVariables 
} from "../../../../../schemaTypes";

export const offersOverviewAdminQuery = gql`
  query OffersOverviewAdminQuery($duration: String!) {
    offersOverviewAdmin(duration: $duration) {
      totalRedeemedOffers
      totalPublishedOffers
      totalExpiredOffers
      totalDraftOffers
      totalScheduledOffers
      totalImpressions
      totalOffersClick
    }
  }
`;

export interface WithOffersOverviewAdmin {
  totalRedeemedOffers: number;
  totalPublishedOffers: number;
  totalExpiredOffers: number;
  totalDraftOffers: number;
  totalScheduledOffers: number;
  totalImpressions: number;
  totalOffersClick: number;
}

interface Props {
  variables: OffersOverviewAdminQueryQueryVariables;
  children: (data: WithOffersOverviewAdmin) => React.ReactElement | null;
}

export const OffersOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    OffersOverviewAdminQueryQuery,
    OffersOverviewAdminQueryQueryVariables
  >(offersOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const totalRedeemedOffers = data?.offersOverviewAdmin?.totalRedeemedOffers || 0;
  const totalPublishedOffers = data?.offersOverviewAdmin?.totalPublishedOffers || 0;
  const totalExpiredOffers = data?.offersOverviewAdmin?.totalExpiredOffers || 0;
  const totalDraftOffers = data?.offersOverviewAdmin?.totalDraftOffers || 0;
  const totalScheduledOffers = data?.offersOverviewAdmin?.totalScheduledOffers || 0;
  const totalImpressions = data?.offersOverviewAdmin?.totalImpressions || 0;
  const totalOffersClick = data?.offersOverviewAdmin?.totalOffersClick || 0;

  return children({
    totalRedeemedOffers,
    totalPublishedOffers,
    totalExpiredOffers,
    totalDraftOffers,
    totalScheduledOffers,
    totalImpressions,
    totalOffersClick,
  });
};